import React from 'react';
import styled from 'styled-components';
import JindalTyreFeature from '../components/featured/JindalTyreFeature';

const Wrapper = styled.div`
  min-height: 70vh;
  padding-top: var(--headerHeight);
  background-color: var(--darkBG);
`;

export default function TyresPage() {
  return (
    <Wrapper>
      <JindalTyreFeature />
    </Wrapper>
  );
}
